<template>
  <div class="pb-6">
    <h3 class="text-lg font-medium leading-6 text-gray-900">{{title}}</h3>
    <p class="mt-1 text-sm text-gray-600">{{subtitle}}</p>
  </div>
</template>
<script>
export default{
  props: {
    title: String,
    subtitle: String
  }
}
</script>
